/**
 * redirects from hellblazer to dasher:
 *
 *  -> https://github.com/stitchfix/hellblazer/blob/8976f1bd1d0545481df79d627e1a6988cea87359/config/routes.rb#L21
 *  -> https://github.com/stitchfix/hellblazer/blob/8976f1bd1d0545481df79d627e1a6988cea87359/app/controllers/style_controller.rb#L48
 *  -> https://github.com/stitchfix/hellblazer/blob/8976f1bd1d0545481df79d627e1a6988cea87359/config/routes.rb#L185
 *  -> https://github.com/stitchfix/dasher/blob/ec03e58058f6cc0f4e2b189eb467d6637be66bc6/config/routes.rb#L15
 */
export const ONBOARDING_START_PATH = '/welcome/style';

// Pre-lower funnel onboarding paths
export const STYLEFILE_PATH = '/onboarding/stylefile';
export const VISION_PATH = '/onboarding/vision';
export const PROFILE_NOTE_PATH = '/onboarding/profile-note';

// Post-lower funnel onboarding paths
export const FIX_FREQUENCY_PATH = '/onboarding/fix-frequency';
export const ADD_A_KID_PATH = '/onboarding/add-a-kid';
export const ADD_A_PROFILE_PATH = '/onboarding/add-a-profile';
export const DOWNLOAD_APP_PATH = '/onboarding/download-app/';

// Post-onboarding paths
export const HOME_FEED_PATH = '/home';
export const FIX_HOME_PATH = '/fix-home';
